var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDrag = function SvgDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".drag_svg__cls-1{fill:#58595b}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Interface-Essential_Menu_navigation-menu-vertical",
    "data-name": "Interface-Essential Menu navigation-menu-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__navigation-menu-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_22",
    d: "M2.5 5A2.5 2.5 0 1 0 0 2.5 2.5 2.5 0 0 0 2.5 5",
    className: "drag_svg__cls-1",
    "data-name": "Oval 22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_23",
    d: "M2.5 14A2.5 2.5 0 1 0 0 11.5 2.5 2.5 0 0 0 2.5 14",
    className: "drag_svg__cls-1",
    "data-name": "Oval 23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_24",
    d: "M2.5 23A2.5 2.5 0 1 0 0 20.5 2.5 2.5 0 0 0 2.5 23",
    className: "drag_svg__cls-1",
    "data-name": "Oval 24"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Interface-Essential_Menu_navigation-menu-vertical-2",
    "data-name": "Interface-Essential Menu navigation-menu-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Group_28-2",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__navigation-menu-vertical-2",
    "data-name": "navigation-menu-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_22-2",
    d: "M11.5 5A2.5 2.5 0 1 0 9 2.5 2.5 2.5 0 0 0 11.5 5",
    className: "drag_svg__cls-1",
    "data-name": "Oval 22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_23-2",
    d: "M11.5 14A2.5 2.5 0 1 0 9 11.5a2.5 2.5 0 0 0 2.5 2.5",
    className: "drag_svg__cls-1",
    "data-name": "Oval 23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_24-2",
    d: "M11.5 23A2.5 2.5 0 1 0 9 20.5a2.5 2.5 0 0 0 2.5 2.5",
    className: "drag_svg__cls-1",
    "data-name": "Oval 24"
  }))))))));
};
export { SvgDrag as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAyNCI+Cgk8ZGVmcz4KCQk8c3R5bGU+LmNscy0xe2ZpbGw6IzU4NTk1Yjt9PC9zdHlsZT4KCTwvZGVmcz4KCTxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEsMC41KSI+CgkJPGcgaWQ9Iklzb2xhdGlvbl9Nb2RlIiBkYXRhLW5hbWU9Iklzb2xhdGlvbiBNb2RlIj4KCQkJPGcgaWQ9IkludGVyZmFjZS1Fc3NlbnRpYWxfTWVudV9uYXZpZ2F0aW9uLW1lbnUtdmVydGljYWwiIGRhdGEtbmFtZT0iSW50ZXJmYWNlLUVzc2VudGlhbCBNZW51IG5hdmlnYXRpb24tbWVudS12ZXJ0aWNhbCI+CgkJCQk8ZyBpZD0iR3JvdXBfMjgiIGRhdGEtbmFtZT0iR3JvdXAgMjgiPgoJCQkJCTxnIGlkPSJuYXZpZ2F0aW9uLW1lbnUtdmVydGljYWwiPgoJCQkJCQk8cGF0aCBpZD0iT3ZhbF8yMiIgZGF0YS1uYW1lPSJPdmFsIDIyIiBjbGFzcz0iY2xzLTEiIGQ9Ik0yLjUsNUEyLjUsMi41LDAsMSwwLDAsMi41LDIuNSwyLjUsMCwwLDAsMi41LDVaIi8+CgkJCQkJCTxwYXRoIGlkPSJPdmFsXzIzIiBkYXRhLW5hbWU9Ik92YWwgMjMiIGNsYXNzPSJjbHMtMSIgZD0iTTIuNSwxNEEyLjUsMi41LDAsMSwwLDAsMTEuNSwyLjUsMi41LDAsMCwwLDIuNSwxNFoiLz4KCQkJCQkJPHBhdGggaWQ9Ik92YWxfMjQiIGRhdGEtbmFtZT0iT3ZhbCAyNCIgY2xhc3M9ImNscy0xIiBkPSJNMi41LDIzQTIuNSwyLjUsMCwxLDAsMCwyMC41LDIuNSwyLjUsMCwwLDAsMi41LDIzWiIvPgoJCQkJCTwvZz4KCQkJCTwvZz4KCQkJPC9nPgoJCQk8ZyBpZD0iSW50ZXJmYWNlLUVzc2VudGlhbF9NZW51X25hdmlnYXRpb24tbWVudS12ZXJ0aWNhbC0yIiBkYXRhLW5hbWU9IkludGVyZmFjZS1Fc3NlbnRpYWwgTWVudSBuYXZpZ2F0aW9uLW1lbnUtdmVydGljYWwiPgoJCQkJPGcgaWQ9Ikdyb3VwXzI4LTIiIGRhdGEtbmFtZT0iR3JvdXAgMjgiPgoJCQkJCTxnIGlkPSJuYXZpZ2F0aW9uLW1lbnUtdmVydGljYWwtMiIgZGF0YS1uYW1lPSJuYXZpZ2F0aW9uLW1lbnUtdmVydGljYWwiPgoJCQkJCQk8cGF0aCBpZD0iT3ZhbF8yMi0yIiBkYXRhLW5hbWU9Ik92YWwgMjIiIGNsYXNzPSJjbHMtMSIgZD0iTTExLjUsNUEyLjUsMi41LDAsMSwwLDksMi41LDIuNSwyLjUsMCwwLDAsMTEuNSw1WiIvPgoJCQkJCQk8cGF0aCBpZD0iT3ZhbF8yMy0yIiBkYXRhLW5hbWU9Ik92YWwgMjMiIGNsYXNzPSJjbHMtMSIgZD0iTTExLjUsMTRBMi41LDIuNSwwLDEsMCw5LDExLjUsMi41LDIuNSwwLDAsMCwxMS41LDE0WiIvPgoJCQkJCQk8cGF0aCBpZD0iT3ZhbF8yNC0yIiBkYXRhLW5hbWU9Ik92YWwgMjQiIGNsYXNzPSJjbHMtMSIgZD0iTTExLjUsMjNBMi41LDIuNSwwLDEsMCw5LDIwLjUsMi41LDIuNSwwLDAsMCwxMS41LDIzWiIvPgoJCQkJCTwvZz4KCQkJCTwvZz4KCQkJPC9nPgoJCTwvZz4KCTwvZz4KPC9zdmc+";